import { Accordion, AccordionDetails, AccordionSummary, Button, CircularProgress, Container, Fab, Grid, Paper, Stack, Typography, colors } from "@mui/material";
import CarbonStepper from "./CarbonStepper";
import { useContext, useEffect, useState } from "react";
import $data from "../../services/$data";
import ParcelMap from "./ParcelMap";

import CarbonApplicability from "./applicability/CarbonApplicability";
import WidgetTitle from "../widgets/WidgetTitle";
import CarbonReporting from "./reporting/CarbonReporting";
import CarbonVerification from "./verification/CarbonVerification";
import { DataContext } from "../DataContext";
import { AppContext } from "../../AppContext";
import CarbonReportPreview from "./CarbonReportPreview";

function CarbonParcel(props) {
  let {selected, onUpdateState} = useContext(AppContext);
  let {id, year, project} = props;

  const {onGetParcels, projectData, onGetDocuments, onGetPhotos} = useContext(DataContext)
  const [loading, setLoading] = useState(true);
  const [applicabilityLoading, setApplicabilityLoading] = useState(true);

  const [error, setError] = useState(false);
  const [step, setStep] = useState(1);
  const [parcel, setParcel] = useState(null);

  const [applicabilityInfo, setApplicabilityInfo] = useState();

  const getParcel = async () => {
    setLoading(true);
    try {
      let data = await $data.getParcels(selected);
      console.log(data);
      console.log(data.find(p => p.id.toString() === props.id.toString())); 

      let parc = data.find(p => p.id.toString() === props.id.toString());
    
      setParcel(parc);
      getApplicabilityStatus(data.id);
      onGetParcels(selected);
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  }

  const getDocuments = async () => {
    try {
      onGetDocuments(project);
    } catch (error) {}
  }

  const getPhotos = async () => {
    try {
      onGetPhotos(project);
    } catch (error) {}
  }

  useEffect(() => {
    getDocuments();
    if(Boolean(selected)) {
      if (Boolean(projectData.hasOwnProperty(selected))) {
        let parcel = projectData[selected].parcels.find(p => p.id.toString() === id);
        setParcel(parcel);
        setLoading(false);
        getApplicabilityStatus(parcel.id)
      }      
    } else {
      onUpdateState({selected: project});
      onGetParcels(project);
      onGetDocuments(project);
      onGetPhotos(project);
      getParcel(props.id);
    }
  }, []);

  console.log(projectData)

  const getApplicabilityStatus = async (parcelID) => {
    setApplicabilityLoading(true);
    try {
      let data = await $data.getApplicabilityForParcel(parcelID);
      setApplicabilityInfo(data);
    } catch (error) {
      console.log(error)
    } finally {
      setApplicabilityLoading(false);
    }
  }

  const getMonitoringStatus = () => {

  }

  const getVerificationStatus = () => {

  }

  const renderParcelInformation = () => {
    return (
      <Stack component={Paper} className="co-background" direction="row" justifyContent={"center"} spacing={2} sx={{ padding: '10px' }}>
        <ParcelMap parcel={parcel} />
      </Stack>
    )
  }

  const renderContent = () => {
    if (loading || applicabilityLoading) {
      return (
        <Grid item xs={12} textAlign={'center'}>
          <CircularProgress color="primary" />
        </Grid>
      )
    }

    if (error) {
      return (
        <Grid item xs={12} textAlign={'center'}>
          <Typography color="error" variant="h6">Error occured while loading parcel information</Typography>
        </Grid>
      )
    }

    if (!parcel) {
      return (
        <Grid item xs={12} textAlign={'center'}>
          <Typography color="primary" variant="h6">Parcel not found</Typography>
        </Grid>
      )
    }

    return (
      <>
        <Grid item xs={12}>
          <Paper elevation={3} className="co-background-white" sx={{ padding: '10px' }}>
            <WidgetTitle text={`Parcel Status Tracking (${props.year})`} />
          </Paper>
        </Grid>
        <Grid item xs={12} textAlign={'center'}>
          {renderParcelInformation()}
        </Grid>
        <Grid item xs={12}>
          <Paper className="co-background-white" elevation={3} sx={{ padding: '20px' }}>
            <CarbonApplicability onUpdateParcel={getParcel} parcel={parcel} applicabilityInfo={applicabilityInfo} loading={applicabilityLoading} />
          </Paper>
        </Grid>
        {/* <Grid item xs={12}>
          <Paper className="co-background-white" elevation={3} sx={{ padding: '20px' }}>
            <CarbonStepper step={step} applicability={parcel.applicabilityStatus} status={parcel.status.find(s => s.year === parseInt(props.year))} />
          </Paper>
        </Grid> */}
        <Grid item xs={12}>
          <Paper className="co-background-white" elevation={3} sx={{ padding: '20px' }}>
            <CarbonReporting onUpdateParcel={getParcel}  project={props.project} year={props.year} parcel={parcel} documents={projectData[project].documents} photos={projectData[project].photos} isEnabled={parcel.applicabilityStatus === 'Approved' && parcel.status.find(s => s.year  === parseInt(props.year))?.monitoring !== 'Approved'} disabled={parcel.applicabilityStatus !== 'Approved'} />
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper className="co-background-white" elevation={3} sx={{ padding: '20px', mb: '40px' }}>
            <CarbonVerification year={props.year} isEnabled={parcel.applicabilityStatus === 'Approved'} />
          </Paper>
        </Grid>

      </>
    )
  }

  return (
    <>
      <Container style={{ marginTop: '30px', marginBottom: '30px' }}>
        <Grid container spacing={2}>
          {renderContent()}
          
        </Grid>
      </Container>
    </>
  );
}

export default CarbonParcel;